import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=578b788b"
import script from "./documentation.vue?vue&type=script&lang=js"
export * from "./documentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports